import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Link,
  Typography,
} from '@mui/material'
import { GoodsItem } from '../components/Goods'
import { Modal } from '../components/Modal'
import { Tc } from '../components/Tc'
import { useGet } from './get'
import { useSwitch } from './switch'

const useTc = (item?: GoodsItem['dto'], checkout?: Dto.Checkout) => {
  const { data: formTc } = useGet<Dto.Tc>(() => {
    if (!item) {
      return
    }

    const formId = item.term_form_id

    if (!formId) {
      return
    }

    return `member_portal/form/${formId}`
  })

  const formTcSwitch = useSwitch()
  const paymentTcSwitch = useSwitch()

  const gymTc = checkout?.terms?.gym
  const paymentTc = checkout?.terms?.payment

  const tcElement = formTc ? (
    <>
      <FormControl>
        <FormControlLabel
          label={
            <Typography variant="body2">
              I've read and accepted{' '}
              <Link
                fontWeight={600}
                color="inherit"
                onClick={formTcSwitch.open}
              >
                Terms & Conditions
              </Link>
            </Typography>
          }
          control={<Checkbox value={formTc.id} required></Checkbox>}
        />
      </FormControl>
      <Modal open={formTcSwitch.on} onClose={formTcSwitch.close}>
        <Tc data={formTc} />
      </Modal>
    </>
  ) : gymTc ? (
    <FormControl>
      <FormControlLabel
        label={
          <Typography variant="body2">
            I've read and accepted{' '}
            <Link
              href={gymTc.url}
              target="_blank"
              fontWeight={600}
              color="inherit"
            >
              Terms & Conditions
            </Link>
          </Typography>
        }
        control={<Checkbox value={gymTc.id} required></Checkbox>}
      />
    </FormControl>
  ) : null
  const paymentTcElement = paymentTc?.url ? (
    <FormControl>
      <FormControlLabel
        label={
          <Typography variant="body2">
            I've read and accepted{' '}
            <Link
              href={paymentTc.url}
              target="_blank"
              fontWeight={600}
              color="inherit"
            >
              Payment Agreement
            </Link>
          </Typography>
        }
        control={<Checkbox value={paymentTc.name} required></Checkbox>}
      />
    </FormControl>
  ) : paymentTc ? (
    <>
      <FormControl>
        <FormControlLabel
          label={
            <Typography variant="body2">
              I've read and accepted{' '}
              <Link
                fontWeight={600}
                color="inherit"
                onClick={paymentTcSwitch.open}
              >
                Payment Agreement
              </Link>
            </Typography>
          }
          control={<Checkbox value={paymentTc.name} required></Checkbox>}
        />
      </FormControl>
      <Modal open={paymentTcSwitch.on} onClose={paymentTcSwitch.close}>
        <Tc data={paymentTc} />
      </Modal>
    </>
  ) : null

  return {
    tcElement,
    paymentTcElement,
    formTc,
    gymTc,
  }
}

export { useTc }
